var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-gamespeed"},[_c('span',[_vm._v(" "+_vm._s(_vm.baseText)+" ")]),(_vm.isPulsing)?_c('span',[_vm._v("("),_c('i',{staticClass:"fas fa-expand-arrows-alt u-fa-padding"}),_vm._v(" "+_vm._s(_vm.pulseSpeedText)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }